import { UserStoreState } from "@/app/stores/user/types"

export const defaultInitialState: UserStoreState = {
  user: null,
  preferences: {
    termKey: process.env.NEXT_PUBLIC_INITIAL_TERM_KEY!,
    interval: process.env.NEXT_PUBLIC_INITIAL_TERM_INTERVAL!,
    calculation: process.env.NEXT_PUBLIC_INITIAL_CALCULATION!,
    chartCode: process.env.NEXT_PUBLIC_INITIAL_CHART!,
    comparisonGroup: process.env.NEXT_PUBLIC_INITIAL_COMPARISON!,
    fundId: process.env.NEXT_PUBLIC_INITIAL_ENTITY_ID!,
    firmId: null,
  },
  isLoggedIn: false,
}
